<template>
   <div class="vouchers">
      <div class="filter">
         <Form 
            class_binding="row justify-content-md-center" 
            :ref="Model.forms.filter_vouchers.name" 
            :forms="Model.forms.filter_vouchers.forms" 
            :form_data="Model.forms.filter_vouchers.data"
            @button-click="filterVouchers({ref: $refs[Model.forms.filter_vouchers.name]})"
         />
      </div>
      
      <div class="dotted-border" v-if="vouchers.length === 0">
         <div class="row justify-content-md-center">
            <div class="col-12 col-md-11 col-lg-10 col-xl-9 action-card">
               <div class="btn btn-transparent btn-primary btn-round"><div :class="Model.tables.vouchers.props.icon"></div></div>
               <div class="title">{{Model.tables.vouchers.props.title}}</div>
               <div class="subtitle">
                  No Vouchers found! Select a date to query.
               </div>
            </div>
         </div>
      </div>
      <Table v-bind="Model.tables.vouchers.props" :data="vouchers" @on-action="handleActions"  v-if="vouchers.length > 0">
         <template slot-scope="{ row }" slot="phone_number">
            <strong class="tx-small">{{ row.phone_number.phone }}</strong>
         </template>
         <template slot-scope="{ row }" slot="paid_at">
            <strong class="tx-small" v-if="row.paid_at">{{ dayjs(row.paid_at).format('DD-MM-YYYY HH:mm') }}</strong>
            <strong class="tx-small" v-else>-</strong>
         </template>
         <template slot-scope="{ row }" slot="receipt_number">
            <strong class="tx-small" v-if="row.payment_data.receipt_number">{{ row.payment_data.receipt_number }}</strong>
            <strong class="tx-small" v-else>-</strong>
         </template>
         <template slot-scope="{ row }" slot="total_amount">
            <strong class="t5">{{utils.numberWithCommas(row.total_amount)}}</strong>
         </template>
      </Table>
   </div>
</template>

<script>
import vouchers from "./vouchers.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('vouchers')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('vouchers',vouchers,this.$store)
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Table: () => import("clarks/components/ivu-table"),
   },
   data (){
      return {
         dayjs,
         utils
      };
   },
   computed: {
      ...mapGetters([
         'Model',
         'vouchers',
         'loading',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'handleActions',
         'filterVouchers',
      ]),
   },
   async mounted(){
      utils.registerModule('vouchers',vouchers,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .vouchers{
      .filter{
         margin: 10px 0 20px 0;
      }
   }
</style>